import Api from "../api";

const smbSales = {
  namespaced: true,
  state: {
    // 用于跨模块的监听 不存信息
    // 公司详情信息
    companyDetailInfo: {},
    // 选择国家和区域
    selectCountryAndRegion: {},
    // 主联系方式
    mainContact: {},
    // 其他联系方式
    otherContacts: {},
    // 合作伙伴合同信息
    partnerContractInfo: {},
    // 销售目标信息
    salesTargetInformation: {},
    // 支持文件信息 比如：合同、授权书等
    supportDocument: {},
    // 企业销售信息
    ruijieSalesInformation: {},
    // 国家返点系数
    countryRebateCoefficient: 1.5,
    // 合同类型partnerType
    partnerType: '',
    lastYearSalesData: {}
  },
  mutations: {
    // 公司详情信息
    SET_COMPANY_DETAIL_INFO(state, payload) {
      state.CompanyDetailInfo = payload;
    },
    // 选择国家和区域
    SET_SELECT_COUNTRY_AND_REGION(state, payload) {
      state.selectCountryAndRegion = payload;
    },
    // 主联系方式
    SET_MAIN_CONTACT(state, payload) {
      state.mainContact = payload;
    },
    // 其他联系方式
    SET_OTHER_CONTACTS(state, payload) {
      state.otherContacts = payload;
    },
    // 合作伙伴合同信息
    SET_PARTNER_CONTRACT_INFO(state, payload) {
      state.partnerContractInfo = payload;
    },
    // 销售目标信息
    SET_SALES_TARGET_INFORMATION(state, payload) {
      state.salesTargetInformation = payload;
    },
    // 支持文件信息 比如：合同、授权书等
    SET_SUPPORT_DOCUMENT(state, payload) {
      state.supportDocument = payload;
    },
    // 企业销售信息
    SET_RUIJIE_SALES_INFORMATION(state, payload) {
      state.ruijieSalesInformation = payload;
    },
    // 设置国家返点系数
    SET_COUNTRY_REBATE_COEFFICIENT(state, payload) {
      state.countryRebateCoefficient = payload;
    },
    // 设置合同类型partnerType
    SET_PARTNER_TYPE(state, payload) {
      state.partnerType = payload;
    },
    // 设置去年销售数据
    SET_LAST_YEAR_SALES_DATA(state, payload) {
      state.lastYearSalesData = payload;
    }
  }
};
export default smbSales;



// WEBPACK FOOTER //
// ./src/store/smbSales.js